import { render, staticRenderFns } from "./MedicineImage.vue?vue&type=template&id=66404e94&"
import script from "./MedicineImage.vue?vue&type=script&lang=ts&"
export * from "./MedicineImage.vue?vue&type=script&lang=ts&"
import style0 from "./MedicineImage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports